export default __webpack_public_path__ + "static/media/Amit.516b394f.png";